/**
 * assets/header-section.js
 * Gedrag van sections/header.liquid
 *
 * Geknipt uit het {% javascript %}-blok van die section op 16-08-2026, 1:1.
 * Shopify plakte die blokken tot één compiled_assets/scripts.js dat op elke
 * pagina laadde, ook waar de section niet voorkwam. Nu laadt alleen deze
 * section zijn eigen gedrag. Zie ARCHITECTURE.md sectie 11.
 */

/*
 * Eenmalige uitvoering. Shopify voegde alle {% javascript %}-blokken samen tot
 * één bestand dat precies één keer draaide, ongeacht hoe vaak de section op de
 * pagina stond. Deze guard houdt dat gedrag exact gelijk nu elke section zijn
 * eigen script-tag rendert.
 */
(function () {
  'use strict';
  if (window.__vc_headerSection) return;
  window.__vc_headerSection = true;

  // ═══ Sticky Header Shadow ═══
    const header = document.querySelector('[data-header]');
    if (header && header.classList.contains('sticky')) {
      window.addEventListener('scroll', () => {
        header.classList.toggle('header--scrolled', window.scrollY > 10);
      }, { passive: true });
    }

    // ═══ Mega Menu Hover Controller ═══
    (function() {
      const triggers = document.querySelectorAll('[data-mega-trigger]');
      const panels = document.querySelectorAll('[data-mega-panel]');
      let closeTimer = null;
      let openTimer = null;
      let activeIdx = null;

      function updateMegaTop() {
        const row = document.querySelector('[data-nav-row]');
        if (row) document.documentElement.style.setProperty('--mega-top', row.getBoundingClientRect().bottom + 'px');
      }
      updateMegaTop();
      window.addEventListener('resize', updateMegaTop, { passive: true });
      window.addEventListener('scroll', updateMegaTop, { passive: true });

      function openMenu(idx) {
        clearTimeout(closeTimer);
        clearTimeout(openTimer);
        if (activeIdx === idx) return;
        updateMegaTop(); // Recalculate position (announcement bars may have shifted layout)
        closeAllMenus();
        // Close search dropdown when mega menu opens (prevents overlap)
        document.querySelectorAll('header predictive-search [data-search-results]').forEach(el => el.classList.add('hidden'));
        document.querySelectorAll('header [data-search-overlay]').forEach(el => el.classList.add('hidden'));
        activeIdx = idx;
        const trigger = document.querySelector(`[data-mega-trigger="${idx}"]`);
        const panel = document.querySelector(`[data-mega-panel="${idx}"]`);
        if (trigger) trigger.classList.add('mega-active');
        if (panel) panel.classList.add('mega-active');
      }

      function closeAllMenus() {
        triggers.forEach(t => t.classList.remove('mega-active'));
        panels.forEach(p => p.classList.remove('mega-active'));
        activeIdx = null;
      }

      function scheduleClose() {
        clearTimeout(openTimer);
        clearTimeout(closeTimer);
        closeTimer = setTimeout(closeAllMenus, 400);
      }

      triggers.forEach(trigger => {
        const idx = trigger.dataset.megaTrigger;
        trigger.addEventListener('mouseenter', () => {
          clearTimeout(closeTimer);
          clearTimeout(openTimer);
          // Als er al een menu open is, wissel direct (geen delay)
          if (activeIdx !== null) {
            openMenu(idx);
          } else {
            // Hover-intent: pas openen na 150ms stilstaan
            openTimer = setTimeout(() => openMenu(idx), 150);
          }
        });
        trigger.addEventListener('mouseleave', scheduleClose);
      });

      panels.forEach(panel => {
        panel.addEventListener('mouseenter', () => clearTimeout(closeTimer));
        panel.addEventListener('mouseleave', scheduleClose);
      });

      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && activeIdx !== null) closeAllMenus();
      });

      document.addEventListener('click', (e) => {
        if (activeIdx !== null && !e.target.closest('[data-mega-trigger]') && !e.target.closest('[data-mega-panel]')) {
          closeAllMenus();
        }
      });
    })();

    // ═══ Dialog Backdrop Close ═══
    document.querySelectorAll('dialog').forEach(dialog => {
      dialog.addEventListener('click', (e) => {
        if (e.target === dialog) dialog.close();
      });
    });

    // ═══ Mobile Search Dialog ═══
    const searchDialog = document.getElementById('search-dialog');
    if (searchDialog) {
      document.querySelectorAll('[data-open-search-dialog]').forEach(btn => {
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          searchDialog.showModal();
          setTimeout(() => {
            const input = searchDialog.querySelector('[data-search-input]');
            if (input) input.focus();
          }, 100);
        });
      });
    }

    // ═══ Rotating Announcement Bar ═══
    const announcements = document.querySelectorAll('[data-announcement]');
    if (announcements.length > 1) {
      let current = 0;
      setInterval(() => {
        announcements[current].classList.add('translate-y-full', 'opacity-0');
        announcements[current].classList.remove('translate-y-0');
        current = (current + 1) % announcements.length;
        announcements[current].classList.remove('translate-y-full', 'opacity-0');
      }, 4000);
    }

    // ═══ Mobile Drill-Down Navigation ═══
    const mobileDialog = document.getElementById('mobile-menu-dialog');
    if (mobileDialog) {
      /* Focus terug op de menuknop na sluiten (Escape of sluitknop). Zonder dit
         kwam de focus op body en begon een toetsenbordgebruiker weer bovenaan
         (toetsenbordtest 27-10-2026, project Design en UX 2027). */
      let menuOpener = null;
      document.addEventListener('click', (e) => {
        const knop = e.target && e.target.closest && e.target.closest('[onclick*="mobile-menu-dialog"], [data-mobile-menu-open]');
        if (knop) menuOpener = knop;
      }, true);
      mobileDialog.addEventListener('close', () => {
        const nu = document.activeElement;
        if (menuOpener && menuOpener.isConnected && (!nu || nu === document.body || mobileDialog.contains(nu))) {
          try { menuOpener.focus(); } catch (_) {}
        }
      });
      const slider = mobileDialog.querySelector('[data-mobile-slider]');
      const backBtn = mobileDialog.querySelector('[data-mobile-back]');
      const titleEl = mobileDialog.querySelector('[data-mobile-title]');
      const defaultTitle = titleEl ? titleEl.innerHTML : '';
      let currentLevel = 1;
      let levelHistory = [];

      function slideTo(level) {
        if (!slider) return;
        const offset = -(level - 1) * (100 / 3);
        slider.style.translate = `${offset}% 0`;
        currentLevel = level;
        if (backBtn) backBtn.style.display = level > 1 ? 'flex' : 'none';
      }

      function setTitle(text) {
        if (titleEl) {
          titleEl.innerHTML = text
            ? `<span class="text-navy font-bold text-lg">${text}</span>`
            : defaultTitle;
        }
      }

      function hideAllPanels(level) {
        mobileDialog.querySelectorAll(`[data-mobile-panel${level}]`).forEach(p => p.classList.add('hidden'));
      }

      mobileDialog.querySelectorAll('[data-mobile-open-level2]').forEach(btn => {
        btn.addEventListener('click', () => {
          const idx = btn.dataset.mobileOpenLevel2;
          hideAllPanels(2);
          const panel = mobileDialog.querySelector(`[data-mobile-panel2="${idx}"]`);
          if (panel) panel.classList.remove('hidden');
          const title = btn.querySelector('span.flex-1')?.textContent?.trim() || '';
          levelHistory.push({ level: 1, title: '' });
          setTitle(title);
          slideTo(2);
        });
      });

      mobileDialog.querySelectorAll('[data-mobile-open-level3]').forEach(btn => {
        btn.addEventListener('click', () => {
          const key = btn.dataset.mobileOpenLevel3;
          hideAllPanels(3);
          const panel = mobileDialog.querySelector(`[data-mobile-panel3="${key}"]`);
          if (panel) panel.classList.remove('hidden');
          const title = btn.textContent?.trim() || '';
          const currentTitle = titleEl?.textContent?.trim() || '';
          levelHistory.push({ level: 2, title: currentTitle });
          setTitle(title);
          slideTo(3);
        });
      });

      if (backBtn) {
        backBtn.addEventListener('click', () => {
          const prev = levelHistory.pop();
          if (prev) {
            setTitle(prev.title || null);
            slideTo(prev.level);
          } else {
            setTitle(null);
            slideTo(1);
          }
        });
      }

      mobileDialog.addEventListener('close', () => {
        slideTo(1);
        setTitle(null);
        levelHistory = [];
        hideAllPanels(2);
        hideAllPanels(3);
      });
    }
})();
